//replaces widget-resize.component.ts

import type { IDashboardWidgetInterface } from "app/components/widget/utils/DashboardWidgetsInterfaces-v2";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import type { FC } from "react";

interface IResizeWidget extends IDashboardWidgetInterface {
    onToggleEnlarge: () => void;
}

export const WidgetResizeV2: FC<IResizeWidget> = (props) => {
    const { widget, onToggleEnlarge } = props;
    const t = useTranslation();

    return (
        <button
            className="widget-list-height-toggle"
            onClick={onToggleEnlarge}
        >
            {widget.pos.sizeY === 1 ? t("widget.table.resize.more") : t("widget.table.resize.less")}
        </button>
    );
};
